export default __webpack_public_path__ + "static/media/IMG_5342.01ee4e4e.JPG";